import React from 'react';
import { H5 } from '../../../../AbstractElements';
import { FormGroup, Input, Label, FormFeedback, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { getFieldAccess } from '../../../../_helper/fieldAccess';
import { validateIban, normalizeFieldValue, REGEX, displayDecimal } from '../../../../_helper/regexHandler';

const ContactInfoForm = ({ formData, errors, handleInputChange, setFormData, fieldPermissions = [], canEdit = true }) => {

    const companyRepAccess = getFieldAccess(fieldPermissions, 'customers.companyrepresentative', canEdit);
    const emailDescAccess = getFieldAccess(fieldPermissions, 'customers.email.emaildescription', canEdit);
    const emailAccess = getFieldAccess(fieldPermissions, 'customers.email.email', canEdit);
    const phoneDescAccess = getFieldAccess(fieldPermissions, 'customers.phones.phonedescription', canEdit);
    const phoneAccess = getFieldAccess(fieldPermissions, 'customers.phones.phone', canEdit);
    const ibanDescAccess = getFieldAccess(fieldPermissions, 'customers.ibans.ibandescription', canEdit);
    const ibanAccess = getFieldAccess(fieldPermissions, 'customers.ibans.iban', canEdit);
    const middlemanAccess = getFieldAccess(fieldPermissions, 'customers.middleman', canEdit);
    const middlemanIbanAccess = getFieldAccess(fieldPermissions, 'customers.middlemaniban', canEdit);
    const middlemanRateAccess = getFieldAccess(fieldPermissions, 'customers.middlemancontractprice', canEdit);
    const isMiddlemanContractBasedAccess = getFieldAccess(fieldPermissions, 'customers.ismiddlemancontractbased', canEdit);
    const middlemanContractPriceAccess = getFieldAccess(fieldPermissions, 'customers.middlemancontractprice', canEdit);

    const ibanValidation = validateIban(formData.iban);
    const iban2Validation = validateIban(formData.iban2);
    const middlemanIbanValidation = validateIban(formData.middlemanIban);

    return (
        <>
            <H5>İletişim Bilgileri</H5>
            <div style={{ height: "20px" }}></div>

            {formData.customerType === 'Kurumsal' && (
                <>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label for="companyRepresentative">
                                    Firma Yetkilisi {companyRepAccess.required && <span className="text-danger">*</span>}
                                </Label>
                                <Input
                                    type="text"
                                    id="companyRepresentative"
                                    name="companyRepresentative"
                                    value={formData.companyRepresentative || ''}
                                    disabled={!companyRepAccess.editable}
                                    onChange={handleInputChange}
                                    invalid={!!errors.companyRepresentative}
                                />
                                <FormFeedback>{errors.companyRepresentative}</FormFeedback>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="emailDescription">
                                    E-Mail Açıklaması {emailDescAccess.required && <span className="text-danger">*</span>}
                                </Label>
                                <Input
                                    type="text"
                                    id="emailDescription"
                                    name="emailDescription"
                                    value={formData.emailDescription || ''}
                                    disabled={!emailDescAccess.editable}
                                    onChange={handleInputChange}
                                    placeholder="Örn: İş E-postası"
                                    invalid={!!errors.emailDescription}
                                />
                                <FormFeedback>{errors.emailDescription}</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label for="email">
                                    E-Mail {emailAccess.required && <span className="text-danger">*</span>}
                                </Label>
                                <Input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email || ''}
                                    disabled={!emailAccess.editable}
                                    onChange={handleInputChange}
                                    invalid={!!errors.email}
                                />
                                <FormFeedback>{errors.email}</FormFeedback>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="emailDescription2">
                                    E-Mail 2 Açıklaması {emailDescAccess.required && <span className="text-danger">*</span>}
                                </Label>
                                <Input
                                    type="text"
                                    id="emailDescription2"
                                    name="emailDescription2"
                                    value={formData.emailDescription2 || ''}
                                    disabled={!emailDescAccess.editable}
                                    onChange={handleInputChange}
                                    placeholder="Örn: Kişisel E-posta"
                                    invalid={!!errors.emailDescription2}
                                />
                                <FormFeedback>{errors.emailDescription2}</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label for="email2">
                                    E-Mail 2 {emailAccess.required && <span className="text-danger">*</span>}
                                </Label>
                                <Input
                                    type="email"
                                    id="email2"
                                    name="email2"
                                    value={formData.email2 || ''}
                                    disabled={!emailAccess.editable}
                                    onChange={handleInputChange}
                                    invalid={!!errors.email2}
                                />
                                <FormFeedback>{errors.email2}</FormFeedback>
                            </FormGroup>
                        </Col>
                    </Row>
                </>
            )}

            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label for="phoneDescription">
                            Telefon Açıklaması {phoneDescAccess.required && <span className="text-danger">*</span>}
                        </Label>
                        <Input
                            type="text"
                            id="phoneDescription"
                            name="phoneDescription"
                            value={formData.phoneDescription || ''}
                            disabled={!phoneDescAccess.editable}
                            onChange={handleInputChange}
                            placeholder="Örn: Ana Telefon"
                            invalid={!!errors.phoneDescription}
                        />
                        <FormFeedback>{errors.phoneDescription}</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                        <Label for="phoneNumber">
                            Telefon Numarası {phoneAccess.required && <span className="text-danger">*</span>}
                        </Label>
                        <Input
                            type="text"
                            id="phoneNumber"
                            name="phoneNumber"
                            value={formData.phoneNumber || ''}
                            disabled={!phoneAccess.editable}
                            onChange={(e) => {
                                let value = normalizeFieldValue('phoneNumber', e.target.value);
                                if (value && !value.startsWith('05')) {
                                    if (value.startsWith('5')) {
                                        value = '0' + value;
                                    } else {
                                        value = '';
                                    }
                                }
                                handleInputChange({
                                    target: {
                                        name: 'phoneNumber',
                                        value
                                    }
                                });
                            }}
                            placeholder="05XX XXX XX XX"
                            maxLength={11}
                            invalid={!!errors.phoneNumber || (formData.phoneNumber && (!formData.phoneNumber.startsWith('05') || formData.phoneNumber.length !== 11))}
                        />
                        <FormFeedback>
                            {errors.phoneNumber || 'Telefon numarası 05 ile başlamalı ve 11 haneli olmalıdır'}
                        </FormFeedback>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label for="phoneDescription2">
                            Telefon 2 Açıklaması {phoneDescAccess.required && <span className="text-danger">*</span>}
                        </Label>
                        <Input
                            type="text"
                            id="phoneDescription2"
                            name="phoneDescription2"
                            value={formData.phoneDescription2 || ''}
                            disabled={!phoneDescAccess.editable}
                            onChange={handleInputChange}
                            placeholder="Örn: Yedek Telefon"
                            invalid={!!errors.phoneDescription2}
                        />
                        <FormFeedback>{errors.phoneDescription2}</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                        <Label for="phoneNumber2">
                            Telefon Numarası 2 {phoneAccess.required && <span className="text-danger">*</span>}
                        </Label>
                        <Input
                            type="text"
                            id="phoneNumber2"
                            name="phoneNumber2"
                            value={formData.phoneNumber2 || ''}
                            disabled={!phoneAccess.editable}
                            onChange={(e) => {
                                let value = normalizeFieldValue('phoneNumber2', e.target.value);
                                if (value && !value.startsWith('05')) {
                                    if (value.startsWith('5')) {
                                        value = '0' + value;
                                    } else {
                                        value = '';
                                    }
                                }
                                handleInputChange({
                                    target: {
                                        name: 'phoneNumber2',
                                        value
                                    }
                                });
                            }}
                            placeholder="05XX XXX XX XX"
                            maxLength={11}
                            invalid={!!errors.phoneNumber2 || (formData.phoneNumber2 && formData.phoneNumber2.length > 0 && (!formData.phoneNumber2.startsWith('05') || formData.phoneNumber2.length !== 11))}
                        />
                        <FormFeedback>
                            {errors.phoneNumber2 || 'Telefon numarası 05 ile başlamalı ve 11 haneli olmalıdır'}
                        </FormFeedback>
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label for="ibanDescription">
                            İban Açıklaması {ibanDescAccess.required && <span className="text-danger">*</span>}
                        </Label>
                        <Input
                            type="text"
                            id="ibanDescription"
                            name="ibanDescription"
                            value={formData.ibanDescription || ''}
                            disabled={!ibanDescAccess.editable}
                            onChange={handleInputChange}
                            placeholder="Örn: Ana Hesap"
                            invalid={!!errors.ibanDescription}
                        />
                        <FormFeedback>{errors.ibanDescription}</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                        <Label for="iban">
                            İban {ibanAccess.required && <span className="text-danger">*</span>}
                        </Label>
                        <Input
                            type="text"
                            id="iban"
                            name="iban"
                            value={formData.iban || ''}
                            disabled={!ibanAccess.editable}
                            onChange={(e) => {
                                const value = normalizeFieldValue('iban', e.target.value);
                                handleInputChange({
                                    target: {
                                        name: 'iban',
                                        value
                                    }
                                });
                            }}
                            placeholder="TR00 0000 0000 0000 0000 0000 00"
                            invalid={!!errors.iban || (formData.iban && !ibanValidation.isValid)}
                        />
                        <FormFeedback>
                            {errors.iban || (formData.iban ? (ibanValidation.error || 'Geçerli bir IBAN giriniz') : '')}
                        </FormFeedback>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label for="ibanDescription2">
                            İban 2 Açıklaması {ibanDescAccess.required && <span className="text-danger">*</span>}
                        </Label>
                        <Input
                            type="text"
                            id="ibanDescription2"
                            name="ibanDescription2"
                            value={formData.ibanDescription2 || ''}
                            disabled={!ibanDescAccess.editable}
                            onChange={handleInputChange}
                            placeholder="Örn: Yedek Hesap"
                            invalid={!!errors.ibanDescription2}
                        />
                        <FormFeedback>{errors.ibanDescription2}</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                        <Label for="iban2">
                            İban 2 {ibanAccess.required && <span className="text-danger">*</span>}
                        </Label>
                        <Input
                            type="text"
                            id="iban2"
                            name="iban2"
                            value={formData.iban2 || ''}
                            disabled={!ibanAccess.editable}
                            onChange={(e) => {
                                const value = normalizeFieldValue('iban2', e.target.value);
                                handleInputChange({
                                    target: {
                                        name: 'iban2',
                                        value
                                    }
                                });
                            }}
                            placeholder="TR00 0000 0000 0000 0000 0000 00"
                            invalid={!!errors.iban2 || (formData.iban2 && formData.iban2.length > 0 && !iban2Validation.isValid)}
                        />
                        <FormFeedback>
                            {errors.iban2 || (formData.iban2 ? (iban2Validation.error || 'Geçerli bir IBAN giriniz') : '')}
                        </FormFeedback>
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label for="middleman">
                            Aracı {middlemanAccess.required && <span className="text-danger">*</span>}
                        </Label>
                        <Input
                            type="text"
                            id="middleman"
                            name="middleman"
                            value={formData.middleman || ''}
                            disabled={!middlemanAccess.editable}
                            onChange={(e) => {
                                const value = normalizeFieldValue('middleman', e.target.value);

                                handleInputChange({
                                    target: {
                                        name: 'middleman',
                                        value
                                    }
                                });
                            }}
                            placeholder="Aracı Ad Soyad"
                            invalid={!!errors.middleman || (formData.middleman && formData.middleman.length > 0 && !REGEX.FULL_NAME_TITLE_TR.test(formData.middleman.trim()))}
                        />
                        <FormFeedback>{errors.middleman || 'Ad ve soyad büyük harfle başlamalı ve en az iki kelimeden oluşmalıdır'}</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label for="middlemanIban">
                            Aracı IBAN {middlemanIbanAccess.required && <span className="text-danger">*</span>}
                        </Label>
                        <Input
                            type="text"
                            id="middlemanIban"
                            name="middlemanIban"
                            value={formData.middlemanIban || ''}
                            disabled={!middlemanIbanAccess.editable}
                            onChange={(e) => {
                                const value = normalizeFieldValue('middlemanIban', e.target.value);
                                handleInputChange({
                                    target: {
                                        name: 'middlemanIban',
                                        value
                                    }
                                });
                            }}
                            maxLength={34}
                            placeholder="TR00 0000 0000 0000 0000 0000 00"
                            invalid={!!errors.middlemanIban || (formData.middlemanIban && !middlemanIbanValidation.isValid)}
                        />
                        <FormFeedback>{errors.middlemanIban || (formData.middlemanIban ? (middlemanIbanValidation.error || 'Geçerli bir IBAN giriniz') : '')}</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md={3}>
                    <FormGroup className="mb-2">
                        <Label>
                            Aracı Ödeme Türü {isMiddlemanContractBasedAccess.required && <span className="text-danger">*</span>}
                        </Label>
                        <div className="d-flex mt-1">
                            <div className="radio radio-primary me-3 d-flex align-items-center">
                                <Input
                                    id="customerIsMiddlemanContractBasedTrue"
                                    type="radio"
                                    name="customerIsMiddlemanContractBased"
                                    value="true"
                                    checked={formData.customerIsMiddlemanContractBased === true || formData.customerIsMiddlemanContractBased === "true"}
                                    onChange={() => handleInputChange({ target: { name: 'customerIsMiddlemanContractBased', value: true } })}
                                    disabled={!isMiddlemanContractBasedAccess.editable}
                                />
                                <Label for="customerIsMiddlemanContractBasedTrue" className="ms-1 mb-0">
                                    Oran Bazlı
                                </Label>
                            </div>
                            <div className="radio radio-primary d-flex align-items-center">
                                <Input
                                    id="customerIsMiddlemanContractBasedFalse"
                                    type="radio"
                                    name="customerIsMiddlemanContractBased"
                                    value="false"
                                    checked={formData.customerIsMiddlemanContractBased === false || formData.customerIsMiddlemanContractBased === "false"}
                                    onChange={() => handleInputChange({ target: { name: 'customerIsMiddlemanContractBased', value: false } })}
                                    disabled={!isMiddlemanContractBasedAccess.editable}
                                />
                                <Label for="customerIsMiddlemanContractBasedFalse" className="ms-1 mb-0">
                                    Fiyat Bazlı
                                </Label>
                            </div>
                        </div>
                        {errors.customerIsMiddlemanContractBased && <FormFeedback style={{ display: 'block' }}>{errors.customerIsMiddlemanContractBased}</FormFeedback>}
                    </FormGroup>
                </Col>
                <Col md={3}>
                    {(formData.customerIsMiddlemanContractBased === true || formData.customerIsMiddlemanContractBased === "true") ? (
                        <FormGroup>
                            <Label for="customerMiddlemanContractRate">
                            Aracı Sözleşme Oranı (%) {middlemanRateAccess.required && <span className="text-danger">*</span>}
                        </Label>
                        <Input
                            type="text"
                                id="customerMiddlemanContractRate"
                                name="customerMiddlemanContractRate"
                                value={displayDecimal(formData.customerMiddlemanContractRate || '')}
                            disabled={!middlemanRateAccess.editable}
                            onChange={(e) => {
                                const value = normalizeFieldValue('customerMiddlemanContractRate', e.target.value);
                                handleInputChange({
                                    target: {
                                            name: 'customerMiddlemanContractRate',
                                        value: value || null
                                    }
                                });
                            }}
                            placeholder="0-100"
                                invalid={!!errors.customerMiddlemanContractRate}
                        />
                            <FormFeedback>{errors.customerMiddlemanContractRate}</FormFeedback>
                        </FormGroup>
                    ) : (
                        <FormGroup>
                            <Label for="customerMiddlemanContractPrice">
                                Aracı Sözleşme Fiyatı (₺) {middlemanContractPriceAccess.required && <span className="text-danger">*</span>}
                            </Label>
                            <Input
                                type="text"
                                id="customerMiddlemanContractPrice"
                                name="customerMiddlemanContractPrice"
                                value={displayDecimal(formData.customerMiddlemanContractPrice || '')}
                                disabled={!middlemanContractPriceAccess.editable}
                                onChange={(e) => {
                                    const value = normalizeFieldValue('customerMiddlemanContractPrice', e.target.value);
                                    handleInputChange({
                                        target: {
                                            name: 'customerMiddlemanContractPrice',
                                            value: value || null
                                        }
                                    });
                                }}
                                placeholder="Örn: 1000,50"
                                invalid={!!errors.customerMiddlemanContractPrice}
                            />
                            <FormFeedback>{errors.customerMiddlemanContractPrice}</FormFeedback>
                    </FormGroup>
                    )}
                </Col>
            </Row>
        </>
    );
};

ContactInfoForm.propTypes = {
    formData: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    setFormData: PropTypes.func.isRequired,
    fieldPermissions: PropTypes.array,
    canEdit: PropTypes.bool,
};

export default ContactInfoForm;
